import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AssetRating } from '../models/asset-rating.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root'
})
export class AssetRatingService {
  
  private pathApi: string;
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'assetRating/';
  }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn);
  }

  save(assetRating: AssetRating): Observable<any> {
    return this.http.post(`${this.pathApi}save`, assetRating);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  }

  getAllForSelect(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForSelect`);
  }
}
